// Copied directly from Publishing-UI: https://github.com/OneAppExchange/publishing-ui/blob/55926572dcbcaa88aaa6f8f6b28e3d4c06f2ce4f/src/modules/utilities/browserUtilities.ts#L98

import { randomUUID } from '~/modules/utilities/cross_env_utils';

export type WithIteratorKey<T> = T & { iteratorKey: string };
export type WithOptionalIteratorKey<T> = T & { iteratorKey?: string };

export function getUniqueIteratorKey() {
    return randomUUID();
}
